import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const ImprintView: FC = () => (
  <Suspense><LazyImprintView/></Suspense>
);

const LazyImprintView = lazy(importView(
  () => import("../components/ImprintView"),
  (it) => it.ImprintView,
));
